import { Component, AfterViewInit, AfterViewChecked, NgZone, ViewChild, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';

import { TdLoadingService, TdMediaService, TdDialogService, } from '@covalent/core';

import { Constante } from '../../../../models/';

import { MasterService, LoginService, ConstantesService, } from '../../../../services/';

@Component({
  selector: 'qs-altaconstante',
  templateUrl: './altaconstante.component.html',
  styles: ['./altaconstante.component.scss'],
  viewProviders: [ConstantesService],
})

export class AltaConstanteComponent implements AfterViewInit, AfterViewChecked, OnDestroy {

  private idPaciente: string;
  public constanteSelected: string;
  public constanteForm: NgForm;

  public constante: any;
  public medida: string = 'Medida: ';
  public constantes: any;
  public toma: string;
  public tomaMax: number = 10000;
  public tomaMin: number = 0;
  public tomaDisabled: boolean = true;

  public fecha: string = '';
  public hora: string = '';

  constructor(private _loadingService: TdLoadingService,
    public media: TdMediaService,
    private _loginService: LoginService,
    private _ngZone: NgZone,
    private _router: Router,
    private _route: ActivatedRoute,
    private _dialogService: TdDialogService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _constantesService: ConstantesService, ) {
  }

  ngAfterViewInit(): void {
    this.media.broadcast();
    this.constantes = [];
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this._loadingService.register('constante.load');
    this._constantesService.obtenerConstantesPaciente(
      this.idPaciente, this._loginService.consulta.sexo, this._loginService.consulta.fechaNacimiento).subscribe((res: any) => {
      this.constantes = res.respuesta.constantes || [];
    });

    let f: any = new Date();
    this.fecha = ('00' + f.getDate()).slice(-2) + '/' + ('00' + (f.getMonth() + 1)).slice(-2) + '/' + f.getFullYear();
    this.hora = ('00' + f.getHours()).slice(-2) + ':' + ('00' + f.getMinutes()).slice(-2);
    this._changeDetectorRef.detectChanges();
  }

  /**
   * FIX: Esto es un fix para ExpressionChangedAfterItHasBeenCheckedError
   * Aparece al cargar un componente de la vista con datos desde un servicio
   */
  ngAfterViewChecked(): void {
    this._changeDetectorRef.detectChanges();
  }

  getTomaValues(event: any): void {
    this.constante = this.constantes.filter((c: any) => { return event.value === c.codigo; });
    // if (this.constante.length === 0) {
      // this.constante = this.constantesCE.filter((c) => { return event.value === c.codigo; });
    // }
    // if (this.constante.length === 0) {
    //  this.constante = this.constantesCG.filter((c) => { return event.value === c.codigo; });
    // }
    // if (this.constante.length === 0) {
    //  this.constante = this.constantes.filter((c) => { return event.value === c.codigo; });
    // }
    this.tomaMax = this.constante[0].maximo;
    this.tomaMin = this.constante[0].minimo;
    this.medida = this.constante[0].medida;
    this.tomaDisabled = false;
  }

  save(form: NgForm): void {
    this._loadingService.register();
    // TODO: Modificar el objeto por el esperado
    let constante: any = {
      iNumExpediente: this._loginService.consulta.numeroExpediente,
      iCip: this._loginService.consulta.cip,
      iFecha: this.fecha,
      iCodigo: this.constante[0].codigo,
      iValor: this.toma,
      iHora: this.hora,
      iDniMed: this._loginService.profesional.Dni,
      iObservacion: '',
      iNumVisita: this._loginService.consulta.visita,
      iIMC: '',
      iDniBorrado: '',
      iMotivoBorrado: '',
      iIdSolicitud: '',
      iVersion: '2',
    };

    this._constantesService.altaConstante(constante).subscribe((res: any) => {
      if (res) {
        this._loginService.mostrarMensaje('Toma de Constante Añadida', 'OK', 6000);
        this._loadingService.resolve();
        this._router.navigate(['/main/consulta/', this._loginService.consulta.numeroExpediente, 'constantes'], { relativeTo: this._route });
      } else {
        this._loginService.mostrarMensaje('Error al insertar Toma de Constante', 'OK', 6000);
        this._loadingService.resolve();
      }
    }, (error: Error) => {
      this._loginService.mostrarMensaje('Error al insertar Toma de Constante', 'OK', 6000);
      this._loadingService.resolve();
    });
  }

  ngOnDestroy(): void {
    this._loginService.transient = undefined;
  }
}



// WEBPACK FOOTER //
// ./src/app/consulta/constantes/altaconstante/altaconstante.component.ts